import { Link } from "react-router-dom"
import RoleBasedNavigator from "../components/RoleBasedNavigator"

export function renderLink ({ value }) {
    return <a href={value} target="_blank">{value}</a>
}

export function renderNavigator (params) {
    return <Link to={`/negotiation/${params?.data?.case_id}/${params?.data?.id}`}>{params.value}</Link>
}

export function renderNavigatorWithState (params) {
    return <Link to={`${params?.data?.id}`} state={params?.data}>{params.value}</Link>
}

export function renderRoleBasedNavigator (params, roles) {
    return <RoleBasedNavigator params={params} allowedRoles={roles} />
}

export function renderDocViewLink (params) {
    return <Link to={`view/${params?.data?.id}`}>{params.value}</Link>
}

export function renderMailto ({ value }) {
    return <a href={`mailto:${value}`}>{value}</a>
}